/**
 * Created by FDD on 2017/5/20.
 */
const TEXTAREA = 'TextArea' // 文本标绘（特殊）
const ARC = 'Arc'
const CURVE = 'Curve'
const GATHERING_PLACE = 'GatheringPlace'
const POLYLINE = 'Polyline'
const FREEHANDLINE = 'FreeHandLine'
const POINT = 'Point'
const PENNANT = 'Pennant'
const RECTANGLE = 'RectAngle'
const CIRCLE = 'Circle'
const ELLIPSE = 'Ellipse'
const LUNE = 'Lune'
const SECTOR = 'Sector'
const CLOSED_CURVE = 'ClosedCurve'
const POLYGON = 'Polygon'
const FREE_POLYGON = 'FreePolygon'
const ATTACK_ARROW = 'AttackArrow'
const DOUBLE_ARROW = 'DoubleArrow'
const STRAIGHT_ARROW = 'StraightArrow'
const FINE_ARROW = 'FineArrow'
const ASSAULT_DIRECTION = 'AssaultDirection'
const TAILED_ATTACK_ARROW = 'TailedAttackArrow'
const SQUAD_COMBAT = 'SquadCombat'
const TAILED_SQUAD_COMBAT = 'TailedSquadCombat'
const RECTFLAG = 'RectFlag'
const TRIANGLEFLAG = 'TriangleFlag'
const CURVEFLAG = 'CurveFlag'
export {
  TEXTAREA,
  ARC,
  CURVE,
  GATHERING_PLACE,
  POLYLINE,
  FREEHANDLINE,
  POINT,
  PENNANT,
  RECTANGLE,
  CIRCLE,
  ELLIPSE,
  LUNE,
  SECTOR,
  CLOSED_CURVE,
  POLYGON,
  FREE_POLYGON,
  ATTACK_ARROW,
  DOUBLE_ARROW,
  STRAIGHT_ARROW,
  FINE_ARROW,
  ASSAULT_DIRECTION,
  TAILED_SQUAD_COMBAT,
  TAILED_ATTACK_ARROW,
  SQUAD_COMBAT,
  RECTFLAG,
  TRIANGLEFLAG,
  CURVEFLAG
}
